import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../adminDashboard/DashboardReportContainer.scss';
// import '../mainDashboard/DashboardStudyItem.scss';
import { AccessibilityContext } from '../../store/accesibility-context';

const DashboarReportContainer = ({
	// id,
	// type,
	title,
    value,
	// role
}) => {
	const navigate = useNavigate();
	const accessibilityCtx = useContext(AccessibilityContext);
	return (
		<div
			className={`${accessibilityCtx.font_Size ? 'stats-item-font':'stats-item'}`}
		>

			<div className='stats-detail-container'>
				<p className='title-type'>{title}</p>
				<p>{`${value}`}</p>
			</div>
		</div>
	);
};

export default DashboarReportContainer;